import { render } from "./BoxInfo.vue?vue&type=template&id=7ad91e7c&scoped=true"
import script from "./BoxInfo.vue?vue&type=script&lang=js"
export * from "./BoxInfo.vue?vue&type=script&lang=js"

import "./BoxInfo.vue?vue&type=style&index=0&id=7ad91e7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad91e7c"]])

export default __exports__